module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.5620/img/business-types/retail.png"